const Application = (id) => `
{
  application(id:"${id}") {
    id
    status
    inactivatedBy
    applicants {
      id
      profilePicture
      index
      image
      started
      email
      documentCategories {
          idProof {
          comment
          ${getDocumentApprovalStatus()}
        }
        incomeBase {
          comment
          ${getDocumentApprovalStatus()}
        }
        rentalAgreement {
          comment
          ${getDocumentApprovalStatus()}
        }
        rentalBase {
          comment
          ${getDocumentApprovalStatus()}
        }
        minUc {
          comment
          ${getDocumentApprovalStatus()}
        }
      }
      application {
        id
      }
      members {
        member1  {
          ${getMember()}
        }
        member2 {
          ${getMember()}
        }
      }
      apartments {
        apartment1 {
          ${getApartment()}
        }
        apartment2 {
         ${getApartment()}
        }
      }
      details {
        swapDate
        details1 {
          ${getDetails()}
        }
        details2 {
          ${getDetails()}
        }
      }
      swapReason  {
        reason
        freeText
        approvalStatus  {
            admin {
              name
              picture
              email
              phone
            }
            date
            type
            message
          }
      }
      documents {
        id
        applicant {
          id
        }
        type
        fileName
        folder
        ${getApprovalStatus()}
        uploadedAt
      }
      bankId {
        ssn
        date
      }
      signed
      reviewed
    }
  }
}
`;

const cancelApplication = (id) => {
  window.debug.log('Cancelling applicaion');
  return `
    mutation {
      inactivateApplication ( applicantId: "${id}" )
    }
  `;
};

const reactivateApplication = (id) => {
  window.debug.log('Reactivating application');
  return `
    mutation {
      reactivateApplication ( applicantId: "${id}")
    }
  `;
};

const setLastActive = (id) => {
  window.debug.log('Setting last active');
  return `
    mutation {
      setLastActive (
        applicantId: "${id}"
      )
    }
  `;
};

const getAllApplications = () => `{
  applications {
    inactivatedBy
    status
    applicants {
      id
      email
      image
      apartments {
        apartment1 {
          address
        }
      }
    }
  }
}`;

export {
  Application,
  getAllApplications,
  cancelApplication,
  reactivateApplication,
  setLastActive,
};

function getApprovalStatus() {
  return `
    approvalStatus {
      admin {
        name
        picture
        email
        phone
      }
      date
      type
      message
    }    
  `;
}

function getDocumentApprovalStatus() {
  return `
    approvalStatus {
      type
      date
    }
  `;
}

function getApartment() {
  return `
    ${getApprovalStatus()}
    address
    apartmentNumber
    area
    city
    hadSince
    landlord
    landlordEmail
    landlordPhone
    objectNumber    
    postalCode
    rent
    rooms    
    childrenCount
    adultCount
  `;
}

function getMember() {
  return `
    ${getApprovalStatus()}
    email
    name
    onCurrentContract
    phone
    registeredAddress
    registeredCity
    registeredPostalCode
    signLink
    ssn
  `;
}

function getDetails() {
  return `
    apartment {      
      ${getApartment()}
    }
    approvalStatus {
      admin {
        name
        picture
        email
        phone
      }
      date
      type
      message
    }
    childrenCount
    freeTextAddress
    moveToApartment
    personCount
  `;
}



// WEBPACK FOOTER //
// ./src/features/App/queries.js